import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { getStoredUser, isAuthenticated as checkAuth } from "@/lib/api";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const passedUser = location.state?.user;
  const [user, setUser] = useState(passedUser || getStoredUser());
  const [isAuthenticated, setIsAuthenticated] = useState(passedUser ? true : null);

  useEffect(() => {
    if (passedUser) {
      setUser(passedUser);
      setIsAuthenticated(true);
      return;
    }

    // If we have a stored user and token, verify server-side
    const checkSession = async () => {
      if (!checkAuth()) {
        setIsAuthenticated(false);
        navigate("/login");
        return;
      }
      try {
        const resp = await api.get("/auth/me");
        setUser(resp.data);
        setIsAuthenticated(true);
      } catch {
        setIsAuthenticated(false);
        navigate("/login");
      }
    };
    checkSession();
  }, [navigate, passedUser]);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#09090B]" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  if (!isAuthenticated) return null;

  return typeof children === "function" ? children(user) : children;
};
